import React, { Component, PropTypes } from 'react';
import Money from 'common/components/money';

/**
 * Awards to be issued.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class Awards extends Component {
  componentDidMount() {
    const { canFetchAwarded, fetchAwardedCreatives, project } = this.props;
    if (canFetchAwarded) {
      fetchAwardedCreatives(project.id);
    }
  }

  render() {
    const { awards, awardedCreatives, canAward } = this.props;
    const awardsLeft = awards.length - awardedCreatives.length;

    if (!canAward) {
      return null;
    }

    return (
      <div className="awards-to-issue">
        { awardedCreatives.length == 0?
        <h3>
          Time to pick the winner. You have {awards.length} award{awards.length > 1 ? 's':''} to issue.
        </h3> :
        <h3>
          { awardsLeft == 0?
          "You have issued all awards.":
          `You have ${awardsLeft} award${(awardsLeft) > 1 ? 's':''} to issue.` }
        </h3> }

        { awardsLeft > 0 &&
        <p>
          Mouse over any entry and click the pink button to award that entry as the winner.
        </p> }

        <div className="row">
          <div className="columns small-16">
            <ul className="awards-list">
          {awards.map((award, i) => {
            const issued = !!awardedCreatives.find(aw => aw.award_uuid == award.uuid);

            return (
              <li key={i} className={"award" + (issued? " issued":"")}>
                Award {i + 1}: <Money value={award.feature.value}/>
              </li>)
          })}
            </ul>
          </div>
        </div>
      </div>)
  }
};

Awards.propTypes = {
  project: PropTypes.object.isRequired,
  awards: PropTypes.array.isRequired,
  awardedCreatives: PropTypes.array.isRequired,
  canAward: PropTypes.bool.isRequired,
  canFetchAwarded: PropTypes.bool.isRequired,
  fetchAwardedCreatives: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/awards.jsx